import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { SchemaBuilder } from '@spartacus/storefront';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BrandSchemaBuilder implements SchemaBuilder {
  constructor(private winRef: WindowRef) {}

  build(): Observable<any> {
    return of(this.collect());
  }

  protected collect(): any {
    return {
      '@context': 'http://schema.org',
      '@type': 'Brand',
      name: 'Строительный двор',
      url: this.winRef.location.origin,
      logo: 'https://sdvor.com/assets/images/logo192.png',
    };
  }
}
